import React from 'react';

type SvgProps = {
    color?: string;
    size?: number;
};

const AktiverVerkehrIcon: React.FC<SvgProps> = ({ color = "white", size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 125 125" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M58.3291 34.2871C63.0983 32.2713 68.6051 34.0412 71.3584 38.417L76.2754 46.2832C80.2087 53.1665 88.0753 58.083 97.417 58.083V67.917C86.6003 67.917 76.7667 63 70.375 55.625L67.4248 70.375L77.75 80.208V117.083H67.917V87.583L57.5918 77.75L48.7412 117.083H38.417L52.1836 47.7588L43.333 51.2002V67.917H33.5V44.8086L58.3291 34.2871ZM70.375 11.375C75.7832 11.375 80.2078 15.7998 80.208 21.208C80.208 26.6163 75.7833 31.042 70.375 31.042C64.9667 31.042 60.542 26.6163 60.542 21.208C60.5422 15.7998 64.9668 11.375 70.375 11.375Z" fill={color} />
    </svg>
);

export default AktiverVerkehrIcon;
